import axios from 'axios'
export default {
  state: {
    designerMaster: [],
    designerProductItem: [],
    designerProducts: [],
    designerProductCategory: [],
    actionMode: null,
    designerId: null
  },
  actions: {
    // 取得designer的資料
    getDesignerDetail ({commit}, {id, designerId}) {
      commit('LOADING', true, {root: true})
      let API_PATH = process.env.API
      return axios.get(`${API_PATH}design/getdesigner/${id}/${designerId}`).then(response => {
        let {designerMaster, productItem: designerProductItem, products: designerProducts, productCategory: designerProductCategory} = response.data.data
        designerProductItem.forEach(function (item) {
          item.shelfDate = new Date(item.shelfDate)
        })
        // 根据shelfDate属性排序（日期最新的在前面）
        designerProductItem.sort(function (a, b) {
          return b.shelfDate - a.shelfDate
        })
        commit('setDesignerData', {designerMaster, designerProductItem, designerProducts, designerProductCategory})
        commit('LOADING', false, {root: true})
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  mutations: {
    setDesignerData (state, {designerMaster, designerProductItem, designerProducts, designerProductCategory}) {
      state.designerMaster = []
      state.designerProductItem = []
      state.designerProducts = []
      state.designerProductCategory = []
      state.designerMaster = designerMaster
      state.designerProductItem = designerProductItem
      state.designerProducts = designerProducts
      state.designerProductCategory = designerProductCategory
      state.actionMode = designerMaster[0].actionMode
      state.designerId = designerMaster[0].designerId
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/designer.js